import React from "react"
import { Link } from "gatsby"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import ColumnsWorksWith from "../components/ColumnsWorksWith"
import ColumnsShopifyStores from "../components/ColumnsShopifyStores"
import TrustedByBanner from "../components/TrustedByBanner"
import illustration from "../assets/images/upfeed-illustration.png"

const HomePage = () => (
  <Layout>
    <Seo
      title="Upfeed - Shopify Optimized Product Feeds"
      description="Optimize your product feed across Pinterest, Facebook, Instagram, and Google to increase traffic, drive more sales and reach customers everywhere. Start your free trial today."
    />
    <div className="container">
      <div className="row row-spacing-6 align-items-center">
        <div className="col-lg-6 col-md-12">
          <h1 className="headline">
            <u>Maximize Revenue</u> from Dynamic Ad Campaigns
          </h1>
          <p className="subheadline">
            Optimize your product feed across Pinterest, Facebook, Instagram,
            and Google to drive more sales and reach customers everywhere.
          </p>
          <div className="pt-4">
            <Link
              to={"https://apps.shopify.com/facebook-shopping-feed"}
              target="_blank"
            >
              <button type="button" className="btn btn-primary btn-lg trial-btn">
                Start Free Trial
              </button>
            </Link>
          </div>
        </div>
        <div className="col-lg-6 col-md-12">
          <img
            src={illustration}
            className="hero-illustration img-fluid"
            alt="Upfeed Product Feed Illustration"
          />
        </div>
      </div>
      <TrustedByBanner />
      <ColumnsShopifyStores />
    </div>
    <ColumnsWorksWith />
  </Layout>
)

export default HomePage
